import { IShop } from "interfaces";
import ShopList from "containers/shopList/shopList";
import cls from "./liked.module.scss";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  data: IShop[];
  isLoading?: boolean;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  fetchingNextPage?: () => void;
};

export default function LikedShops({
  data,
  isLoading = false,
  hasNextPage,
  isFetchingNextPage,
  fetchingNextPage,
}: Props) {
  const { t } = useTranslation();
  const handleFetchNextPage = () => {
    if (hasNextPage && fetchingNextPage) {
      fetchingNextPage();
    }
  };
  return (
    <>
      <h1 className={cls.title}>{t("saved.shops")}</h1>
      <ShopList
        shops={data}
        loading={isLoading}
        fetchingNextPage={isFetchingNextPage}
        hasNextPage={hasNextPage}
        fetchNextPage={handleFetchNextPage}
      />
    </>
  );
}
